<template>
  <section class="publish-page">
    <!-- Croix arménienne (khatchkar) : réutilisée via <use> -->
    <svg width="0" height="0" style="position:absolute" aria-hidden="true" focusable="false">
      <symbol id="hk-cross" viewBox="-34 -40 453 752">
<mask id="hkm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="5" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="17" stroke-linejoin="round" mask="url(#hkm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="44" r="5.7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="44" r="5.7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="112" cy="88" r="5.7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="272" cy="88" r="5.7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="208" r="5.7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="48" cy="302" r="5.7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="208" r="5.7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="338" cy="302" r="5.7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="140" cy="602" r="5.7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="245" cy="602" r="5.7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="110" cy="592" r="5.7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="6"/>
<circle cx="275" cy="592" r="5.7" fill="currentColor"/>
<circle cx="192" cy="245" r="74" fill="none" stroke="currentColor" stroke-width="5"/>
<line x1="252.0" y1="245.0" x2="265.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="255.4" x2="263.9" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="265.5" x2="260.6" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="275.0" x2="255.2" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="283.6" x2="247.9" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="291.0" x2="238.9" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="297.0" x2="228.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="301.4" x2="217.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="304.1" x2="204.7" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="305.0" x2="192.0" y2="318.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="304.1" x2="179.3" y2="316.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="301.4" x2="167.0" y2="313.6" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="297.0" x2="155.5" y2="308.2" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="291.0" x2="145.1" y2="300.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="283.6" x2="136.1" y2="291.9" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="275.0" x2="128.8" y2="281.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="265.5" x2="123.4" y2="270.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="255.4" x2="120.1" y2="257.7" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.0" y1="245.0" x2="119.0" y2="245.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="132.9" y1="234.6" x2="120.1" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<line x1="135.6" y1="224.5" x2="123.4" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="140.0" y1="215.0" x2="128.8" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="146.0" y1="206.4" x2="136.1" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="153.4" y1="199.0" x2="145.1" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="162.0" y1="193.0" x2="155.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="171.5" y1="188.6" x2="167.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="181.6" y1="185.9" x2="179.3" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="192.0" y1="185.0" x2="192.0" y2="172.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="202.4" y1="185.9" x2="204.7" y2="173.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="212.5" y1="188.6" x2="217.0" y2="176.4" stroke="currentColor" stroke-width="2.5"/>
<line x1="222.0" y1="193.0" x2="228.5" y2="181.8" stroke="currentColor" stroke-width="2.5"/>
<line x1="230.6" y1="199.0" x2="238.9" y2="189.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="238.0" y1="206.4" x2="247.9" y2="198.1" stroke="currentColor" stroke-width="2.5"/>
<line x1="244.0" y1="215.0" x2="255.2" y2="208.5" stroke="currentColor" stroke-width="2.5"/>
<line x1="248.4" y1="224.5" x2="260.6" y2="220.0" stroke="currentColor" stroke-width="2.5"/>
<line x1="251.1" y1="234.6" x2="263.9" y2="232.3" stroke="currentColor" stroke-width="2.5"/>
<circle cx="192" cy="245" r="52" fill="none" stroke="currentColor" stroke-width="6"/>
<path d="M202.0 245.0 L205.5 246.7 L208.7 249.3 L211.4 252.6 L213.4 256.7 L214.7 261.4 L215.1 266.5 L214.6 272.0 L213.0 277.6 L210.3 283.3 L206.5 288.7" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 252.1 L200.3 255.7 L200.8 259.8 L200.3 264.1 L198.9 268.4 L196.5 272.6 L193.1 276.6 L188.9 280.1 L183.7 282.9 L177.9 285.0 L171.4 286.1" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 255.0 L190.3 258.5 L187.7 261.7 L184.4 264.4 L180.3 266.4 L175.6 267.7 L170.5 268.1 L165.0 267.6 L159.4 266.0 L153.7 263.3 L148.3 259.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 252.1 L181.3 253.3 L177.2 253.8 L172.9 253.3 L168.6 251.9 L164.4 249.5 L160.4 246.1 L156.9 241.9 L154.1 236.7 L152.0 230.9 L150.9 224.4" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M182.0 245.0 L178.5 243.3 L175.3 240.7 L172.6 237.4 L170.6 233.3 L169.3 228.6 L168.9 223.5 L169.4 218.0 L171.0 212.4 L173.7 206.7 L177.5 201.3" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M184.9 237.9 L183.7 234.3 L183.2 230.2 L183.7 225.9 L185.1 221.6 L187.5 217.4 L190.9 213.4 L195.1 209.9 L200.3 207.1 L206.1 205.0 L212.6 203.9" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M192.0 235.0 L193.7 231.5 L196.3 228.3 L199.6 225.6 L203.7 223.6 L208.4 222.3 L213.5 221.9 L219.0 222.4 L224.6 224.0 L230.3 226.7 L235.7 230.5" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M199.1 237.9 L202.7 236.7 L206.8 236.2 L211.1 236.7 L215.4 238.1 L219.6 240.5 L223.6 243.9 L227.1 248.1 L229.9 253.3 L232.0 259.1 L233.1 265.6" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="8" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="7" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="3.5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="3.5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="3.5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="3.5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="3.5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="3.5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="3.5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="4" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"/>
      </symbol>
      <symbol id="hk-cross-sm" viewBox="-44 -40 473 752">
<mask id="hkm-sm" maskUnits="userSpaceOnUse" x="-20" y="-20" width="425" height="710"><rect x="-20" y="-20" width="425" height="710" fill="#fff"/><path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="#000" stroke-width="6" stroke-linejoin="round"/></mask>
<path d="M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z" fill="none" stroke="currentColor" stroke-width="19" stroke-linejoin="round" mask="url(#hkm-sm)"/>
<g transform="translate(98 40) rotate(-45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(287 40) rotate(45)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 166) rotate(70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(356 344) rotate(110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(291 645) rotate(135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(97 645) rotate(-135)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 344) rotate(-110)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<g transform="translate(29 166) rotate(-70)"><path d="M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z" fill="currentColor"/></g>
<circle cx="140" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="44" r="7" fill="currentColor"/>
<circle cx="245" cy="44" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="44" r="7" fill="currentColor"/>
<circle cx="112" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="112" cy="88" r="7" fill="currentColor"/>
<circle cx="272" cy="88" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="272" cy="88" r="7" fill="currentColor"/>
<circle cx="48" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="208" r="7" fill="currentColor"/>
<circle cx="48" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="48" cy="302" r="7" fill="currentColor"/>
<circle cx="338" cy="208" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="208" r="7" fill="currentColor"/>
<circle cx="338" cy="302" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="338" cy="302" r="7" fill="currentColor"/>
<circle cx="140" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="140" cy="602" r="7" fill="currentColor"/>
<circle cx="245" cy="602" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="245" cy="602" r="7" fill="currentColor"/>
<circle cx="110" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="110" cy="592" r="7" fill="currentColor"/>
<circle cx="275" cy="592" r="15" fill="none" stroke="currentColor" stroke-width="8"/><circle cx="275" cy="592" r="7" fill="currentColor"/>
<circle cx="192" cy="245" r="76" fill="none" stroke="currentColor" stroke-width="8"/>
<line x1="254.0" y1="245.0" x2="266.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="266.2" x2="261.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="284.9" x2="248.7" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="298.7" x2="229.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="306.1" x2="204.8" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="306.1" x2="179.2" y2="317.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="298.7" x2="155.0" y2="309.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="284.9" x2="135.3" y2="292.6" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="266.2" x2="122.5" y2="270.3" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="130.0" y1="245.0" x2="118.0" y2="245.0" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="133.7" y1="223.8" x2="122.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="144.5" y1="205.1" x2="135.3" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="161.0" y1="191.3" x2="155.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="181.2" y1="183.9" x2="179.2" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="202.8" y1="183.9" x2="204.8" y2="172.1" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="223.0" y1="191.3" x2="229.0" y2="180.9" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="239.5" y1="205.1" x2="248.7" y2="197.4" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<line x1="250.3" y1="223.8" x2="261.5" y2="219.7" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
<circle cx="192" cy="245" r="54" fill="none" stroke="currentColor" stroke-width="9"/>
<path d="M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1" fill="none" stroke="currentColor" stroke-width="11" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="192" cy="245" r="9" fill="currentColor"/>
<path d="M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<path d="M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round"/>
<circle cx="192" cy="330.0" r="5" fill="currentColor"/>
<circle cx="192" cy="356.7" r="5" fill="currentColor"/>
<circle cx="192" cy="383.4" r="5" fill="currentColor"/>
<circle cx="192" cy="410.1" r="5" fill="currentColor"/>
<circle cx="192" cy="436.8" r="5" fill="currentColor"/>
<circle cx="192" cy="463.5" r="5" fill="currentColor"/>
<circle cx="192" cy="490.2" r="5" fill="currentColor"/>
<g transform="translate(192 170) rotate(0)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<g transform="translate(192 555) rotate(180)"><path d="M0 18 L0 -6" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><path d="M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z" fill="currentColor"/></g>
<path d="M192 560 L165 590 L192 600 L219 590Z" fill="none" stroke="currentColor" stroke-width="6" stroke-linejoin="round"/>
      </symbol>
    </svg>

    <div class="bg" aria-hidden="true">
      <div class="lattice"></div>
      <svg class="bg-cross"><use href="#hk-cross" /></svg>
    </div>

    <div class="container">

      <!-- ============ EN-TÊTE ============ -->
      <header class="header">
        <span class="kicker">
          <svg class="kicker-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
          Entraide communautaire
        </span>
        <h1>Demandes d'aide <em>publiées</em></h1>
        <p>
          Découvrez les membres de notre communauté qui ont besoin
          d'un accompagnement. Ensemble, nous pouvons aider.
        </p>
      </header>

      <!-- ============ CHARGEMENT ============ -->
      <div v-if="loading" class="skeleton-wrap" aria-busy="true" aria-live="polite">
        <div class="loading-label">
          <span class="loader"></span>
          Chargement des demandes...
        </div>
        <div class="publishs-grid">
          <div v-for="n in 6" :key="n" class="publish-card skeleton">
            <div class="sk sk-img"></div>
            <div class="sk sk-line"></div>
            <div class="sk sk-line short"></div>
          </div>
        </div>
      </div>

      <!-- ============ CONTENU ============ -->
      <template v-else>

        <div class="filters">
          <label class="search">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
            <input
              v-model="search"
              type="search"
              placeholder="Rechercher une demande..."
              aria-label="Rechercher une demande"
            >
          </label>

          <div class="filters-row">
            <div class="filter-buttons" role="group" aria-label="Filtrer par urgence">
              <button
                type="button"
                :class="{ active: urgencyFilter === '' }"
                @click="urgencyFilter = ''"
              >
                Toutes
              </button>

              <button
                type="button"
                :class="{ active: urgencyFilter === 'Normal' }"
                @click="urgencyFilter = 'Normal'"
              >
                <i class="dot green"></i> Normal
              </button>

              <button
                type="button"
                :class="{ active: urgencyFilter === 'Important' }"
                @click="urgencyFilter = 'Important'"
              >
                <i class="dot orange"></i> Important
              </button>

              <button
                type="button"
                :class="{ active: urgencyFilter === 'Urgent' }"
                @click="urgencyFilter = 'Urgent'"
              >
                <i class="dot red"></i> Urgent
              </button>
            </div>

            <div class="date-wrap">
              <input
                v-model="dateFilter"
                class="date"
                type="date"
                aria-label="Filtrer par date"
              >
            </div>
          </div>
        </div>

        <div class="count-row">
          <p class="count">
            <strong>{{ filteredPublishs.length }}</strong>
            demande(s) disponible(s)
          </p>

          <button
            v-if="hasFilters"
            type="button"
            class="reset-btn"
            @click="resetFilters"
          >
            Réinitialiser les filtres
          </button>
        </div>

        <div
          v-if="filteredPublishs.length"
          class="publishs-grid"
        >
          <article
            v-for="(publish, index) in filteredPublishs"
            :key="publish.publicId"
            class="publish-card"
            :class="`is-${publish.urgency}`"
            :style="{ '--i': Math.min(index, 8) }"
          >
            <div class="card-media">
              <img
                :src="publish.image || defaultHelpImage"
                class="publish-image"
                :alt="`Image de la demande de ${publish.name}`"
                loading="lazy"
              />
              <span class="urgency" :class="publish.urgency">
                <i class="dot"></i>
                {{ publish.urgency }}
              </span>
            </div>

            <div class="card-body">
              <div class="card-header">
                <div class="avatar">
                  {{ publish.name.charAt(0).toUpperCase() }}
                </div>

                <div class="who">
                  <h3>{{ publish.name }}</h3>
                  <span v-if="formatDate(publish.createdAt)" class="date-label">
                    Publié le {{ formatDate(publish.createdAt) }}
                  </span>
                </div>
              </div>

              <p class="message">
                {{ truncate(publish.message) }}
              </p>

              <button
                type="button"
                class="details-btn"
                @click="openRequestDetails(publish.publicId)"
              >
                <span>Voir les détails</span>
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6"/></svg>
              </button>
            </div>
          </article>
        </div>

        <div
          v-else
          class="empty"
        >
          <svg class="empty-cross" aria-hidden="true"><use href="#hk-cross-sm" /></svg>
          <h3>Aucune demande trouvée</h3>
          <p>Essayez de modifier votre recherche ou vos filtres.</p>
          <button
            v-if="hasFilters"
            type="button"
            class="reset-btn solid"
            @click="resetFilters"
          >
            Réinitialiser les filtres
          </button>
        </div>

      </template>

    </div>
  </section>
</template>


<script setup>

import {
  ref,
  computed,
  onMounted
} from "vue"

import { useRouter } from "vue-router"
import API_URL from "@/config/api"
import defaultHelpImage from "@/assets/default-help.png"

const router = useRouter()

const publishs = ref([])

const loading = ref(true)

const search = ref("")
const urgencyFilter = ref("")
const dateFilter = ref("")

const openRequestDetails = (publicId) => {
  let user = null
  try {
  user = JSON.parse(localStorage.getItem("user"))
} catch {
  user = null
}

  if (!user?.token) {
    router.push("/login")
    return
  }

  router.push(`/requests/${publicId}`)
}

const truncate = (text) => {

  if (!text)
    return ""

  const maxLength = 150

  return text.length > maxLength
    ? text.substring(0, maxLength) + "..."
    : text

}

const formatDate = (value) => {
  if (!value) return ""
  const d = new Date(value)
  if (isNaN(d)) return ""
  return d.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric"
  })
}

const hasFilters = computed(() =>
  Boolean(search.value || urgencyFilter.value || dateFilter.value)
)

const resetFilters = () => {
  search.value = ""
  urgencyFilter.value = ""
  dateFilter.value = ""
}


const filteredPublishs = computed(() => {

  return publishs.value.filter(p => {

    if (
      search.value &&
      !`${p.name}${p.message}`
        .toLowerCase()
        .includes(search.value.toLowerCase())
    ) {
      return false
    }

    if (
      urgencyFilter.value &&
      p.urgency !== urgencyFilter.value
    ) {
      return false
    }

    if (dateFilter.value) {

      const date = new Date(p.createdAt)
        .toISOString()
        .split("T")[0]

      if (date !== dateFilter.value) {
        return false
      }

    }

    return true

  })

})


const loadPublishs = async () => {

  loading.value = true

  try {

    const response = await fetch(
      `${API_URL}/api/HelpRequests/public`
    )

    if (!response.ok) {
      throw new Error("Erreur lors du chargement")
    }

    publishs.value = await response.json()

  } catch (error) {

    console.error(
      "Erreur lors du chargement des demandes :",
      error
    )

  } finally {

    loading.value = false

  }

}


onMounted(loadPublishs)

</script>


<style>
@import url("https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,400;9..144,600;9..144,700&family=Instrument+Sans:wght@400;500;600;700&family=Noto+Serif+Armenian:wght@400;700&display=swap");
</style>


<style scoped>
.publish-page {
  --red: #d90012;
  --red-deep: #8f0010;
  --blue: #0033a0;
  --orange: #f2a800;
  --ink: #1c1511;
  --ink-soft: #3a2f28;
  --muted: #6e6259;
  --paper: #faf6ef;
  --paper-2: #f3ecdf;
  --line: rgba(28, 21, 17, 0.12);
  --serif: "Fraunces", "Noto Serif Armenian", Georgia, serif;
  --sans: "Instrument Sans", "Inter", system-ui, sans-serif;
  --arm: "Noto Serif Armenian", "Fraunces", serif;

  position: relative;
  min-height: 100vh;
  padding: 130px clamp(16px, 5vw, 72px) 110px;
  overflow: hidden;
  background: var(--paper);
  color: var(--ink);
  font-family: var(--sans);
  -webkit-font-smoothing: antialiased;
}

.publish-page *,
.publish-page *::before,
.publish-page *::after {
  box-sizing: border-box;
}

/* ---------- Fond khatchkar ---------- */
.bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.lattice {
  position: absolute;
  inset: 0 0 auto 0;
  height: 620px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='104' height='163' viewBox='-60 -50 505 792' fill='none' opacity='.24'%3E%3Cmask id='m' maskUnits='userSpaceOnUse' x='-20' y='-20' width='425' height='710'%3E%3Crect x='-20' y='-20' width='425' height='710' fill='%23fff'/%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23000' stroke-width='6' stroke-linejoin='round'/%3E%3C/mask%3E%3Cpath d='M100 40 Q190 98 285 40 Q256 112 238 188 Q300 170 355 165 Q330 245 355 345 Q300 322 238 304 Q250 450 255 600 Q285 622 290 645 Q192 598 100 645 Q130 622 130 600 Q135 450 146 304 Q90 322 30 345 Q55 245 30 165 Q90 170 146 188 Q128 112 100 40 Z' fill='none' stroke='%23d90012' stroke-width='19' stroke-linejoin='round' mask='url(%23m)'/%3E%3Cg transform='translate(98 40) rotate(-45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(287 40) rotate(45)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 166) rotate(70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(356 344) rotate(110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(291 645) rotate(135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(97 645) rotate(-135)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 344) rotate(-110)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(29 166) rotate(-70)'%3E%3Cpath d='M0 4 C-24 -8 -22 -52 0 -72 C22 -52 24 -8 0 4Z' fill='%23d90012'/%3E%3C/g%3E%3Ccircle cx='140' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='44' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='44' r='7' fill='%23d90012'/%3E%3Ccircle cx='112' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='112' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='272' cy='88' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='272' cy='88' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='48' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='48' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='208' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='208' r='7' fill='%23d90012'/%3E%3Ccircle cx='338' cy='302' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='338' cy='302' r='7' fill='%23d90012'/%3E%3Ccircle cx='140' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='140' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='245' cy='602' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='245' cy='602' r='7' fill='%23d90012'/%3E%3Ccircle cx='110' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='110' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='275' cy='592' r='15' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Ccircle cx='275' cy='592' r='7' fill='%23d90012'/%3E%3Ccircle cx='192' cy='245' r='76' fill='none' stroke='%23d90012' stroke-width='8'/%3E%3Cline x1='254.0' y1='245.0' x2='266.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='266.2' x2='261.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='284.9' x2='248.7' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='298.7' x2='229.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='306.1' x2='204.8' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='306.1' x2='179.2' y2='317.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='298.7' x2='155.0' y2='309.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='284.9' x2='135.3' y2='292.6' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='266.2' x2='122.5' y2='270.3' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='130.0' y1='245.0' x2='118.0' y2='245.0' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='133.7' y1='223.8' x2='122.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='144.5' y1='205.1' x2='135.3' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='161.0' y1='191.3' x2='155.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='181.2' y1='183.9' x2='179.2' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='202.8' y1='183.9' x2='204.8' y2='172.1' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='223.0' y1='191.3' x2='229.0' y2='180.9' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='239.5' y1='205.1' x2='248.7' y2='197.4' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Cline x1='250.3' y1='223.8' x2='261.5' y2='219.7' stroke='%23d90012' stroke-width='5' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='245' r='54' fill='none' stroke='%23d90012' stroke-width='9'/%3E%3Cpath d='M207.0 245.0 L209.9 247.4 L212.4 250.7 L214.3 254.6 L215.5 259.1 L215.8 264.1 L215.2 269.3 L213.5 274.7 L210.8 280.1 L206.9 285.2 L202.1 289.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 256.7 L201.3 260.5 L200.3 264.5 L198.4 268.4 L195.6 272.2 L191.9 275.5 L187.4 278.3 L182.1 280.4 L176.3 281.6 L169.9 281.8 L163.2 280.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 259.6 L185.6 261.9 L181.9 263.7 L177.7 264.6 L173.0 264.8 L168.1 264.0 L163.1 262.2 L158.2 259.3 L153.6 255.5 L149.5 250.6 L146.0 244.8' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 251.5 L174.8 250.6 L171.1 248.8 L167.7 246.1 L164.7 242.5 L162.3 238.2 L160.6 233.1 L159.7 227.5 L159.9 221.5 L161.1 215.3 L163.4 208.9' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M178.5 238.5 L176.9 235.0 L176.0 231.0 L176.0 226.7 L176.9 222.1 L178.8 217.5 L181.7 213.0 L185.5 208.9 L190.3 205.2 L196.0 202.3 L202.4 200.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M188.7 230.4 L190.4 227.0 L193.0 223.8 L196.4 221.1 L200.5 219.0 L205.3 217.5 L210.6 217.0 L216.2 217.4 L222.0 218.9 L227.9 221.5 L233.5 225.2' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M201.4 233.3 L205.1 232.5 L209.2 232.6 L213.4 233.5 L217.7 235.4 L221.7 238.3 L225.5 242.1 L228.7 246.7 L231.1 252.2 L232.8 258.4 L233.4 265.1' fill='none' stroke='%23d90012' stroke-width='11' stroke-linecap='round' stroke-linejoin='round'/%3E%3Ccircle cx='192' cy='245' r='9' fill='%23d90012'/%3E%3Cpath d='M192.0 330.0 L195.0 333.0 L197.9 336.0 L200.6 339.0 L203.0 342.0 L205.1 345.0 L206.8 348.0 L208.1 351.0 L208.8 354.0 L209.0 357.0 L208.7 360.0 L207.8 363.0 L206.5 366.0 L204.7 369.0 L202.6 372.0 L200.1 375.0 L197.3 378.0 L194.4 381.0 L191.4 384.0 L188.4 387.0 L185.6 390.0 L182.9 393.0 L180.5 396.0 L178.5 399.0 L176.9 402.0 L175.8 405.0 L175.1 408.0 L175.0 411.0 L175.4 414.0 L176.4 417.0 L177.8 420.0 L179.7 423.0 L181.9 426.0 L184.5 429.0 L187.2 432.0 L190.2 435.0 L193.2 438.0 L196.1 441.0 L199.0 444.0 L201.6 447.0 L203.9 450.0 L205.8 453.0 L207.4 456.0 L208.4 459.0 L208.9 462.0 L208.9 465.0 L208.4 468.0 L207.4 471.0 L205.9 474.0 L203.9 477.0 L201.6 480.0 L199.0 483.0 L196.2 486.0 L193.2 489.0 L190.2 492.0 L187.3 495.0 L184.5 498.0 L181.9 501.0 L179.7 504.0 L177.8 507.0 L176.4 510.0 L175.5 513.0 L175.0 516.0 L175.1 519.0 L175.8 522.0 L176.9 525.0 L178.5 528.0 L180.5 531.0 L182.9 534.0 L185.5 537.0 L188.4 540.0 L191.4 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Cpath d='M192.0 330.0 L189.0 333.0 L186.1 336.0 L183.4 339.0 L181.0 342.0 L178.9 345.0 L177.2 348.0 L175.9 351.0 L175.2 354.0 L175.0 357.0 L175.3 360.0 L176.2 363.0 L177.5 366.0 L179.3 369.0 L181.4 372.0 L183.9 375.0 L186.7 378.0 L189.6 381.0 L192.6 384.0 L195.6 387.0 L198.4 390.0 L201.1 393.0 L203.5 396.0 L205.5 399.0 L207.1 402.0 L208.2 405.0 L208.9 408.0 L209.0 411.0 L208.6 414.0 L207.6 417.0 L206.2 420.0 L204.3 423.0 L202.1 426.0 L199.5 429.0 L196.8 432.0 L193.8 435.0 L190.8 438.0 L187.9 441.0 L185.0 444.0 L182.4 447.0 L180.1 450.0 L178.2 453.0 L176.6 456.0 L175.6 459.0 L175.1 462.0 L175.1 465.0 L175.6 468.0 L176.6 471.0 L178.1 474.0 L180.1 477.0 L182.4 480.0 L185.0 483.0 L187.8 486.0 L190.8 489.0 L193.8 492.0 L196.7 495.0 L199.5 498.0 L202.1 501.0 L204.3 504.0 L206.2 507.0 L207.6 510.0 L208.5 513.0 L209.0 516.0 L208.9 519.0 L208.2 522.0 L207.1 525.0 L205.5 528.0 L203.5 531.0 L201.1 534.0 L198.5 537.0 L195.6 540.0 L192.6 543.0' fill='none' stroke='%23d90012' stroke-width='10' stroke-linecap='round'/%3E%3Ccircle cx='192' cy='330.0' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='356.7' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='383.4' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='410.1' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='436.8' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='463.5' r='5' fill='%23d90012'/%3E%3Ccircle cx='192' cy='490.2' r='5' fill='%23d90012'/%3E%3Cg transform='translate(192 170) rotate(0)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cg transform='translate(192 555) rotate(180)'%3E%3Cpath d='M0 18 L0 -6' stroke='%23d90012' stroke-width='6' stroke-linecap='round'/%3E%3Cpath d='M0 -6 C-14 -10 -14 -28 0 -24 C14 -28 14 -10 0 -6Z' fill='%23d90012'/%3E%3C/g%3E%3Cpath d='M192 560 L165 590 L192 600 L219 590Z' fill='none' stroke='%23d90012' stroke-width='6' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-size: 104px 163px;
  -webkit-mask-image: radial-gradient(
    ellipse 70% 80% at 50% 0%,
    #000 0%,
    transparent 75%
  );
  mask-image: radial-gradient(
    ellipse 70% 80% at 50% 0%,
    #000 0%,
    transparent 75%
  );
}

.bg-cross {
  position: absolute;
  top: 60px;
  right: 1vw;
  width: clamp(150px, 19vw, 290px);
  aspect-ratio: 453 / 752;
  height: auto;
  color: rgba(217, 0, 18, 0.1);
  user-select: none;
}

.container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  min-width: 0;
}

/* ---------- En-tête ---------- */
.header {
  max-width: 760px;
  margin: 0 auto 48px;
  text-align: center;
  animation: rise 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.kicker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: var(--red);
  font: 700 13px/1 var(--sans);
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.kicker-cross {
  width: 19px;
  height: 32px;
  flex-shrink: 0;
}

.kicker::before,
.kicker::after {
  width: 24px;
  height: 2px;
  flex-shrink: 0;
  background: var(--red);
  content: "";
}

.header h1 {
  margin: 18px 0 0;
  color: var(--ink);
  font: 600 clamp(36px, 5.4vw, 66px) / 1.06 var(--serif);
  letter-spacing: -0.03em;
  overflow-wrap: anywhere;
}

.header h1 em {
  color: var(--red);
  font-weight: 500;
}

.header p {
  max-width: 600px;
  margin: 22px auto 0;
  color: var(--ink-soft);
  font-size: clamp(16px, 1.5vw, 19px);
  line-height: 1.7;
}

/* ---------- Filtres ---------- */
.filters {
  position: relative;
  min-width: 0;
  padding: 18px;
  border: 1px solid var(--line);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.85);
  box-shadow: 0 20px 50px rgba(28, 21, 17, 0.07);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  animation: rise 0.8s 0.1s cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.filters::before {
  position: absolute;
  inset: 0 28px auto;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: linear-gradient(
    90deg,
    var(--red) 0 42%,
    var(--blue) 42% 72%,
    var(--orange) 72%
  );
  content: "";
}

.search {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  min-height: 56px;
  padding: 0 20px;
  border: 1.5px solid transparent;
  border-radius: 18px;
  background: var(--paper);
  color: var(--muted);
  cursor: text;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background 0.2s ease;
}

.search:focus-within {
  border-color: var(--red);
  background: #fff;
  box-shadow: 0 0 0 4px rgba(217, 0, 18, 0.08);
  color: var(--red);
}

.search svg {
  flex-shrink: 0;
}

.search input {
  width: 100%;
  min-width: 0;
  min-height: 54px;
  padding: 0;
  border: none;
  outline: none;
  background: none;
  color: var(--ink);
  font: 500 16px var(--sans);
}

.search input::placeholder {
  color: var(--muted);
  opacity: 0.8;
}

.filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  min-width: 0;
  margin-top: 14px;
}

.filter-buttons {
  display: flex;
  flex: 1 1 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.filter-buttons button {
  display: inline-flex;
  flex: 0 1 auto;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  min-height: 44px;
  padding: 0 18px;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  background: #fff;
  color: var(--ink-soft);
  font: 600 14px/1 var(--sans);
  white-space: nowrap;
  cursor: pointer;
  transition:
    transform 0.25s ease,
    background 0.25s ease,
    color 0.25s ease,
    border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.filter-buttons button:hover {
  transform: translateY(-2px);
  border-color: var(--ink);
}

.filter-buttons button.active {
  border-color: var(--ink);
  background: var(--ink);
  color: #fff;
  box-shadow: 0 10px 22px rgba(28, 21, 17, 0.2);
}

.filter-buttons button:focus-visible,
.details-btn:focus-visible,
.reset-btn:focus-visible {
  outline: 3px solid var(--orange);
  outline-offset: 3px;
}

.dot {
  display: inline-block;
  width: 9px;
  height: 9px;
  flex: 0 0 9px;
  border-radius: 50%;
  background: currentColor;
}

.dot.green {
  background: #16a34a;
}

.dot.orange {
  background: var(--orange);
}

.dot.red {
  background: var(--red);
}

.date-wrap {
  flex: 0 1 230px;
  min-width: 210px;
  max-width: 100%;
}

.date {
  display: block;
  width: 100%;
  min-width: 0;
  min-height: 44px;
  padding: 0 16px;
  border: 1.5px solid var(--line);
  border-radius: 999px;
  background: #fff;
  color: var(--ink);
  font: 600 14px var(--sans);
  -webkit-appearance: none;
  appearance: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.date:focus {
  border-color: var(--red);
  outline: none;
  box-shadow: 0 0 0 4px rgba(217, 0, 18, 0.08);
}

.date::-webkit-datetime-edit,
.date::-webkit-datetime-edit-month-field,
.date::-webkit-datetime-edit-day-field,
.date::-webkit-datetime-edit-year-field {
  color: var(--ink);
}

.date::-webkit-datetime-edit-text {
  color: var(--muted);
}

.date::-webkit-calendar-picker-indicator {
  opacity: 1;
  cursor: pointer;
}

/* ---------- Compteur ---------- */
.count-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin: 30px 4px 22px;
}

.count {
  margin: 0;
  color: var(--muted);
  font-size: 15px;
  font-weight: 500;
}

.count strong {
  margin-right: 4px;
  color: var(--ink);
  font: 600 24px var(--serif);
  letter-spacing: -0.02em;
}

.reset-btn {
  padding: 8px 14px;
  border: 0;
  border-radius: 999px;
  background: rgba(217, 0, 18, 0.08);
  color: var(--red-deep);
  font: 700 13px var(--sans);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.reset-btn:hover {
  background: var(--red);
  color: #fff;
}

.reset-btn.solid {
  min-height: 44px;
  padding: 0 22px;
  background: var(--red);
  color: #fff;
}

.reset-btn.solid:hover {
  background: var(--red-deep);
}

/* ---------- Grille des publications ---------- */
.publishs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 320px), 1fr));
  gap: 26px;
  min-width: 0;
}

.publish-card {
  --accent: var(--blue);

  position: relative;
  display: flex;
  min-width: 0;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid var(--line);
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(28, 21, 17, 0.06);
  transition:
    transform 0.4s cubic-bezier(0.2, 0.8, 0.2, 1),
    box-shadow 0.4s ease,
    border-color 0.3s ease;
  animation: rise 0.7s calc(var(--i, 0) * 0.07s) cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.publish-card.is-Normal {
  --accent: #16a34a;
}

.publish-card.is-Important {
  --accent: var(--orange);
}

.publish-card.is-Urgent {
  --accent: var(--red);
}

.publish-card::after {
  position: absolute;
  inset: auto 0 0 0;
  height: 4px;
  background: var(--accent);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.5s cubic-bezier(0.2, 0.8, 0.2, 1);
  content: "";
}

.publish-card:hover {
  transform: translateY(-8px);
  border-color: transparent;
  box-shadow: 0 30px 60px rgba(28, 21, 17, 0.14);
}

.publish-card:hover::after {
  transform: scaleX(1);
}

.card-media {
  position: relative;
  height: 210px;
  overflow: hidden;
  background: var(--paper-2);
}

.publish-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.8s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.publish-card:hover .publish-image {
  transform: scale(1.07);
}

.card-media::after {
  position: absolute;
  inset: auto 0 0 0;
  height: 70px;
  background: linear-gradient(180deg, transparent, rgba(28, 21, 17, 0.18));
  content: "";
  pointer-events: none;
}

.urgency {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: calc(100% - 32px);
  padding: 8px 14px;
  border-radius: 999px;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.16);
  font: 700 12px/1 var(--sans);
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.urgency .dot {
  width: 8px;
  height: 8px;
  flex-basis: 8px;
}

.urgency.Normal {
  color: #15803d;
}

.urgency.Important {
  color: #b45309;
}

.urgency.Urgent {
  color: #b91c1c;
}

.urgency.Urgent .dot {
  animation: pulse 1.8s ease-out infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(217, 0, 18, 0.5);
  }

  70%,
  100% {
    box-shadow: 0 0 0 8px rgba(217, 0, 18, 0);
  }
}

.card-body {
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
  padding: 24px 26px 26px;
}

.card-header {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.avatar {
  display: grid;
  flex-shrink: 0;
  width: 50px;
  height: 50px;
  place-items: center;
  border-radius: 50%;
  background: var(--ink);
  color: var(--orange);
  font: 700 22px/1 var(--serif);
}

.who {
  min-width: 0;
  flex: 1;
}

.who h3 {
  margin: 0;
  overflow: hidden;
  font: 600 22px/1.2 var(--serif);
  letter-spacing: -0.015em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.date-label {
  display: block;
  margin-top: 4px;
  color: var(--muted);
  font-size: 13px;
}

.message {
  display: -webkit-box;
  margin: 18px 0 24px;
  overflow: hidden;
  color: var(--ink-soft);
  font-size: 15.5px;
  line-height: 1.7;
  overflow-wrap: anywhere;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}

.details-btn {
  display: inline-flex;
  width: 100%;
  min-height: 50px;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: auto;
  padding: 0 22px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: transparent;
  color: var(--ink);
  font: 700 15px/1 var(--sans);
  cursor: pointer;
  transition:
    background 0.25s ease,
    color 0.25s ease,
    border-color 0.25s ease,
    box-shadow 0.25s ease;
}

.details-btn svg {
  flex-shrink: 0;
  transition: transform 0.25s ease;
}

.publish-card:hover .details-btn,
.details-btn:hover {
  border-color: var(--red);
  background: var(--red);
  color: #fff;
  box-shadow: 0 12px 26px rgba(217, 0, 18, 0.28);
}

.details-btn:hover svg {
  transform: translateX(5px);
}

/* ---------- État vide ---------- */
.empty {
  display: flex;
  max-width: 560px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 20px auto 0;
  padding: 50px 30px;
  border: 1.5px dashed rgba(28, 21, 17, 0.25);
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.6);
  text-align: center;
  animation: rise 0.7s both;
}

.empty-cross {
  width: 76px;
  height: 126px;
  color: var(--red);
}

.empty h3 {
  margin: 4px 0 0;
  font: 600 26px var(--serif);
  letter-spacing: -0.02em;
}

.empty p {
  margin: 0 0 14px;
  color: var(--muted);
}

/* ---------- Chargement ---------- */
.loading-label {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 30px;
  color: var(--muted);
  font-size: 15px;
  font-weight: 500;
}

.loader {
  width: 26px;
  height: 26px;
  border: 3px solid var(--line);
  border-top-color: var(--red);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.publish-card.skeleton {
  min-height: 360px;
  padding: 0 0 26px;
  animation: none;
}

.publish-card.skeleton:hover {
  transform: none;
  box-shadow: 0 10px 30px rgba(28, 21, 17, 0.06);
}

.publish-card.skeleton::after {
  display: none;
}

.sk {
  background: linear-gradient(
    100deg,
    #f1ebe0 30%,
    #faf6ef 50%,
    #f1ebe0 70%
  );
  background-size: 200% 100%;
  animation: shimmer 1.4s linear infinite;
}

.sk-img {
  height: 210px;
}

.sk-line {
  height: 16px;
  margin: 24px 26px 0;
  border-radius: 8px;
}

.sk-line.short {
  width: 55%;
  margin-top: 14px;
}

@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}

@keyframes rise {
  from {
    opacity: 0;
    transform: translateY(26px);
  }
}

/* ---------- Responsive tablette et mobile ---------- */
@media (max-width: 720px) {
  .publish-page {
    padding: 108px 16px 80px;
  }

  .bg-cross {
    top: 76px;
    right: -34px;
    width: 150px;
    opacity: 0.7;
  }

  .lattice {
    height: 480px;
    background-size: 80px 125px;
  }

  .header {
    margin-bottom: 34px;
  }

  .header h1 {
    font-size: clamp(34px, 8vw, 48px);
  }

  .header p {
    margin-top: 16px;
    font-size: 16px;
  }

  .filters {
    padding: 14px;
    border-radius: 22px;
  }

  .filters::before {
    inset-inline: 20px;
  }

  .search {
    gap: 10px;
    padding-inline: 14px;
  }

  .search input {
    font-size: 16px;
  }

  .filters-row {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  /*
   * Correction principale :
   * les quatre filtres sont disposés sur deux colonnes.
   * Plus de défilement horizontal ni de boutons coupés.
   */
  .filter-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
    gap: 8px;
    width: 100%;
    min-width: 0;
    margin: 0;
    padding: 2px 0 4px;
    overflow: visible;
  }

  .filter-buttons button {
    display: inline-flex;
    width: 100%;
    min-width: 0;
    min-height: 44px;
    padding: 0 8px;
    gap: 6px;
    justify-content: center;
    font-size: 13px;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
  }

  .filter-buttons button:hover {
    transform: none;
  }

  .filter-buttons .dot {
    width: 8px;
    height: 8px;
    flex-basis: 8px;
  }

  .date-wrap {
    width: 100%;
    min-width: 0;
    max-width: none;
    flex: 1 1 auto;
  }

  .date {
    width: 100%;
    min-width: 0;
  }

  .count-row {
    align-items: flex-start;
    margin: 24px 2px 18px;
  }

  .publishs-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 18px;
  }

  .publish-card:hover {
    transform: none;
  }

  .card-body {
    padding: 22px 20px 22px;
  }

  .who h3 {
    font-size: 20px;
  }

  .message {
    font-size: 15px;
  }

  .empty {
    padding: 38px 20px;
  }
}

/* ---------- Très petits écrans ---------- */
@media (max-width: 380px) {
  .publish-page {
    padding-inline: 12px;
  }

  .filters {
    padding: 12px;
    border-radius: 18px;
  }

  .filters::before {
    inset-inline: 16px;
  }

  .filter-buttons {
    gap: 7px;
  }

  .filter-buttons button {
    gap: 5px;
    padding-inline: 5px;
    font-size: 12px;
  }

  .filter-buttons .dot {
    width: 7px;
    height: 7px;
    flex-basis: 7px;
  }

  .card-body {
    padding-inline: 16px;
  }

  .avatar {
    width: 44px;
    height: 44px;
  }

  .who h3 {
    font-size: 18px;
  }

  .urgency {
    top: 12px;
    left: 12px;
    padding: 7px 10px;
    font-size: 11px;
  }

  .empty {
    padding-inline: 16px;
  }
}

/* ---------- Accessibilité ---------- */
@media (prefers-reduced-motion: reduce) {
  .publish-page *,
  .publish-page *::before,
  .publish-page *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
</style>